import {getModule} from 'vuex-module-decorators';
import {CategoriesModule, featureKey as categoriesFeatureKey} from '@/store/categories.store';
import {ChallengesModule, featureKey as challengeFeatureKey} from '@/store/challenges.store';
import {featureKey as userFeatureKey, UserModule} from '@/store/user.store';
import {FaqsStoreModule, featureKey as faqFeatureKey} from '@/store/faqs.store.module';
import {GalleryStoreModule, featureKey as galleryFeatureKey } from '@/store/gallery.store.module';
import {PublicProfileStoreModule, featureKey as publicProfileFeatureKey } from '@/store/public-profile.store.module';
import {featureKey as forumFeatureKey, ForumTopicsStore} from '@/store/forum.store.module';
import {AuthStoreModule, featureKey as authFeatureKey} from '@/store/auth.store.module';
import {CountryStoreModule, featureKey as countryFeatureKey} from '@/store/country.store.module';
import {featureKey as leagueFeatureKey, LeagueStoreModule} from '@/store/league.store.module';
import {featureKey as impactBoardFeatureKey, ImpactBoardMembersStoreModule} from '@/store/impact-board-members.store.module';
import {featureKey as repliesFeatureKey, ForumRepliesStore} from '@/store/forum.replies.store.module';
import {featureKey as i18nFeatureKey, I18nStoreModule} from '@/store/i18n.store.module';
import {namespace} from 'vuex-class';
import {featureKey as teamFeatureKey, TeamsStoreModule} from '@/store/teams.store.module';
import {AdvisersStoreModule, featureKey as advisersFeatureKey} from '@/store/advisers.store.module';
import {featureKey as judgesFeatureKey, JudgesStoreModule} from '@/store/judges.store.module';
import {ChallengeProblemsStoreModule, featureKey as problemFeatureKey} from '@/store/challenge.problems.store.module';
import {
  ChallengeCommunityStoreModule,
  featureKey as communityFeatureKey,
} from '@/store/challenge.community.store.module';
import {ChallengeTimelineStoreModule, featureKey as timelineFeatureKey} from '@/store/challenge-timeline.store.module';
import {featureKey as taskFeatureKey, TasksStoreModule} from '@/store/tasks.store.module';
import {AcceptedChallengesStoreModule, featureKey as acceptFeatureKey} from '@/store/accepted.challenges.store.module';
import {TimelineInteractionStoreModule, featureKey as timelineInteractionFeatureKey} from '@/store/timeline-interactions.store.module';
import {TimelineRepliesStoreModule, featureKey as timelineRepliesFeatureKey} from '@/store/timeline-replies.store.module';
import {featureKey as followFeatureKey, FollowedChallengesStoreModule} from '@/store/followed.challenges.store.module';
import {
  ChallengesInComingStoreModule,
  featureKey as incomingFeatureKey
} from '@/store/challenges-in-coming.store.module';
import {
  ChallengesInProgressStoreModule,
  featureKey as inProgressFeatureKey
} from '@/store/challenges-in-progress.store.module';
import {
  ChallengesFinishedStoreModule,
  featureKey as finishedFeatureKey
} from '@/store/challenges-finished.store.module';
import {featureKey as userTeamsFeatureKey, UserTeamsStoreModule} from '@/store/user-teams.store.module';
import {UserTeamsInvitationsStoreModule, featureKey as invitationsFeatureKey} from '@/store/user-teams-invitations.store.module';
import {FilesStoreModule, featureKey as filesFeatureKey} from '@/store/files.store.module';
import {PartnersStoreModule, featureKey as partnersFeatureKey} from '@/store/partners.store.module';
import {CertificateStoreModule, featureKey as certificatesFeatureKey} from '@/store/certificate.store.module';

export const categoriesState = getModule(CategoriesModule);
export const challengesState = getModule(ChallengesModule);
export const userState = getModule(UserModule);
export const faqsState = getModule(FaqsStoreModule);
export const galleryState = getModule(GalleryStoreModule);
export const publicProfileState = getModule(PublicProfileStoreModule);
export const forumState = getModule(ForumTopicsStore);
export const filesState = getModule(FilesStoreModule);
export const forumRepliesState = getModule(ForumRepliesStore);
export const authState = getModule(AuthStoreModule);
export const countriesState = getModule(CountryStoreModule);
export const leagueState = getModule(LeagueStoreModule);
export const impactBoardMembersState = getModule(ImpactBoardMembersStoreModule);
export const i18nState = getModule(I18nStoreModule);
export const teamsState = getModule(TeamsStoreModule);
export const advisersState = getModule(AdvisersStoreModule);
export const judgesState = getModule(JudgesStoreModule);
export const partnersState = getModule(PartnersStoreModule);
export const certificatesState = getModule(CertificateStoreModule);
export const challengeProblemsState = getModule(ChallengeProblemsStoreModule);
export const challengeCommunityState = getModule(ChallengeCommunityStoreModule);
export const timelineState = getModule(ChallengeTimelineStoreModule);
export const tasksState = getModule(TasksStoreModule);
export const acceptedState = getModule(AcceptedChallengesStoreModule);
export const followedState = getModule(FollowedChallengesStoreModule);
export const finishedChallengesState = getModule(ChallengesFinishedStoreModule);
export const inProgressChallengesState = getModule(ChallengesInProgressStoreModule);
export const incomingChallengesState = getModule(ChallengesInComingStoreModule);
export const userTeamsState = getModule(UserTeamsStoreModule);
export const userTeamInvitesState = getModule(UserTeamsInvitationsStoreModule);
export const timelineInteractionState = getModule(TimelineInteractionStoreModule);
export const timelineRepliesState = getModule(TimelineRepliesStoreModule);

export const authModule = namespace(authFeatureKey);
export const i18nModule = namespace(i18nFeatureKey);
export const forumRepliesModule = namespace(repliesFeatureKey);
export const leagueModule = namespace(leagueFeatureKey);
export const impactBoardMembersModule = namespace(impactBoardFeatureKey);
export const countryModule = namespace(countryFeatureKey);
export const categoriesModule = namespace(categoriesFeatureKey);
export const challengeModule = namespace(challengeFeatureKey);
export const userModule = namespace(userFeatureKey);
export const faqModule = namespace(faqFeatureKey);
export const galleryModule = namespace(galleryFeatureKey);
export const publicProfileModule = namespace(publicProfileFeatureKey);
export const forumModule = namespace(forumFeatureKey);
export const filesModule = namespace(filesFeatureKey);
export const teamModule = namespace(teamFeatureKey);
export const advisersModule = namespace(advisersFeatureKey);
export const partnersModule = namespace(partnersFeatureKey);
export const certificatesModule = namespace(certificatesFeatureKey);
export const judgesModule = namespace(judgesFeatureKey);
export const challengeProblemsModule = namespace(problemFeatureKey);
export const challengeCommunityModule = namespace(communityFeatureKey);
export const timelineModule = namespace(timelineFeatureKey);
export const tasksModule = namespace(taskFeatureKey);
export const acceptedModule = namespace(acceptFeatureKey);
export const followedModule = namespace(followFeatureKey);
export const incomingChallengesModule = namespace(incomingFeatureKey);
export const inProgressChallengesModule = namespace(inProgressFeatureKey);
export const finishedChallengesModule = namespace(finishedFeatureKey);
export const userTeamsModule = namespace(userTeamsFeatureKey);
export const userTeamInvitesModule = namespace(invitationsFeatureKey);
export const timelineInteractionModule = namespace(timelineInteractionFeatureKey);
export const timelineRepliesModule = namespace(timelineRepliesFeatureKey);
